import {
  AppBar,
  Box,
  Dialog,
  IconButton,
  Slide,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { forwardRef, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useForm } from "react-hook-form";
import BaseInput from "components/shared/baseForm/BaseInput";
import { REQUIRED_ERROR } from "utils/errorMessages";
import { useAddFacilityEmployeeMutation } from "store/apis/OrdersApi";
import BaseSubmitButton from "../baseSubmitButton/BaseSubmitButton";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AddEmployee({ open, onSaved, facilityId }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "all",
    defaultValues: {
      firstName: "",
      lastName: "",
      employeeId: "",
    },
  });

  const handleClose = () => {
    onSaved();
  };

  const [
    addEmployee,
    { isSubmitting: employeeSaving, isSuccess: employeeSuccess },
  ] = useAddFacilityEmployeeMutation();

  const onSubmit = (data) => {
    // Prevent duplicate submissions
    if (isSubmitting) return; 
    
    setIsSubmitting(true);
    const payload = {
      ...data,
      facilityId: facilityId,
    };
    addEmployee(payload);
  };

  useEffect(() => {
    if (!employeeSaving && employeeSuccess) {
      setIsSubmitting(false);
      handleClose();
    }
  }, [employeeSaving, employeeSuccess]);

  // Reset form when modal opens
  useEffect(() => {
    if (open) {
      reset();
      setIsSubmitting(false);
    }
  }, [open, reset]);

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}>
      <AppBar position="static">
        <Toolbar>
          <IconButton color="inherit" onClick={handleClose} aria-label="Close">
            <CloseIcon />
          </IconButton>
          <Typography
            variant="h6"
            fontWeight="bold"
            color="inherit"
            sx={{ marginLeft: ".25rem" }}>
            Add New Employee
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          padding: "2rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}>
        <Box sx={{ width: "75vw", marginBottom: "1.5rem" }}>
          <BaseInput
            id="firstName"
            control={control}
            errors={errors}
            name="firstName"
            type="text"
            label="First Name"
            placeholder="Enter First Name"
            validationProps={{
              required: REQUIRED_ERROR("First Name"),
              maxLength: {
                value: 24,
                message: "First Name cannot be over 24 characters",
              },
            }}
            fullWidth
            variant="outlined"
          />
        </Box>
        <Box sx={{ width: "75vw", marginBottom: "1.5rem" }}>
          <BaseInput
            id="lastName"
            control={control}
            errors={errors}
            name="lastName"
            type="text"
            label="Last Name"
            placeholder="Enter Last Name"
            validationProps={{
              required: REQUIRED_ERROR("Last Name"),
              maxLength: {
                value: 24,
                message: "Last Name cannot be over 24 characters",
              },
            }}
            fullWidth
            variant="outlined"
          />
        </Box>
        <Box sx={{ width: "75vw", marginBottom: "1.5rem" }}>
          <BaseInput
            id="employeeId"
            control={control}
            errors={errors}
            name="employeeId"
            type="text"
            label="Employee ID (Optional)"
            placeholder="Enter Employee ID"
            validationProps={{
              maxLength: {
                value: 25,
                message: "Employee ID cannot be over 25 characters",
              },
            }}
            fullWidth
            variant="outlined"
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "1rem",
          }}>
          <BaseSubmitButton
            variant="contained"
            color="primary"
            onClick={handleSubmit(onSubmit)}
            disabled={isSubmitting || employeeSaving}
            sx={{ minWidth: "150px" }}
            text="ADD"
          />
        </Box>
      </Box>
    </Dialog>
  );
}
